import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import router from '../router/index'
import {
  getToken,
  setToken,
  removeToken,
  getTempToken,
  setTempToken,
  removeTempToken,
} from './auth'

function request(data) {
  if((!getToken() || !localStorage.getItem('token')) && router.history.current.path == '/' && data.url != '/get/getCpAppConfig') {
    return
  }
  let instance = axios.create({
    baseURL: process.env.BASE_API,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      'authorization': localStorage.getItem('token')
    },
  })
  instance.interceptors.response.use(res => {
    if(res.data.code==410 || res.data.code==400){
      getCpAppConfig();
    }
    return res
  },
  error => {
    // alert('请求失败，请稍后重试！')
    console.log('请求失败，请稍后重试！')
    return Promise.reject(error)
    }
  )

  instance({
    method: data.method,
    url: data.url,
    data: Qs.stringify(data.data),
    params: data.params
    })
  .then(res => {
    if (res.data.code === 410) {
    return
    }
    data.success(res)
  })
  .catch(error => {
    console.log(error);
  })
}

function getCpAppConfig() {
  let method = "post";
  let url = process.env.BASE_API + '/get/getCpAppConfig';
  let host = location.host;
  let domain = host.substr(0,host.indexOf('.'))
  axios({
    method,
    url,
    data: Qs.stringify({
    domain: domain,
    }),
    headers: {
    "X-Requested-With": "XMLHttpRequest"
    }
  }).then(res => {
    let appId = res.data.data.app_id;
    let isGuest = res.data.data.is_guest || 0;
    if(res.data.status == 'success' && isGuest == 1) {
    location.replace(`${process.env.AUTO_LOGIN}?app_id=${appId}`)
    } else {
    router.push('/logOut?type=1');
    }
  }).catch(()=>{
    removeToken();
  });
}

export default request



// WEBPACK FOOTER //
// ./src/utils/requestAxios.js